export default __webpack_public_path__ + "static/joko-app-screenshot-home-en-e9fa09ae41390f6a1e12d96c183e2ef9.webp";